import { useState } from 'react';

import { getOrCreateFeatureFlag } from '../../../config/FeatureFlag';

import type { FeatureFlagName } from '../../../config/FeatureFlagNames';

/**
 * @deprecated One-shot snapshot: reads the flag once after LaunchDarkly initializes and never
 * updates again, even if the flag/context changes later (e.g. after an async `identify()` call).
 * Use a reactive `get` getter on the `FeatureFlag` class instead, read via
 * {@link getOrCreateFeatureFlag} inside a component wrapped in `observer(...)`.
 */
export function useFeatureFlag<T = any>(key: FeatureFlagName, defaultValue: T): T {
	const [state, setState] = useState<T>(defaultValue);
	const [isInitialized, setIsInitialized] = useState<boolean>(false);

	const { client } = getOrCreateFeatureFlag();
	if (client && !isInitialized) {
		client
			.waitForInitialization(5)
			.then((): void => {
				const value = getOrCreateFeatureFlag().getFeatureValue<T>(key, defaultValue);
				setState(value);
				setIsInitialized(true);
			})
			.catch((err): void => console.error('error initializing LDClient', err));
	}

	return state;
}
